import { getCurrencySymbol } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import type { Currency } from '@recruitee/pricing-types';
import type { PaymentInterval } from '@recruitee/subscription-types';
import { MathPipe } from '@recruitee/user-interface';

@Component({
  selector: 'rt-plan-picker-product-price',
  templateUrl: './plan-picker-product-price.component.html',
  styleUrls: ['./plan-picker-product-price.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MathPipe, TranslatePipe],
})
export class PlanPickerProductPriceComponent {
  @Input() public interval: PaymentInterval;
  @Input() public currency: Currency;
  @Input() public costPerMonth: number;
  @Input() public costPerMonthWithoutDiscount: number;

  public currencySymbol: string;

  public ngOnChanges() {
    this.currencySymbol = getCurrencySymbol(this.currency, 'narrow');
  }
}
